module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1 hidden",
    attrs: {
      "data-number": "1",
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('h1', {
    staticClass: "hidden",
    attrs: {
      "data-number": "1",
      "epub:type": "epigraph"
    }
  }, [_vm._v("Epigraph")]), _vm._v(" "), _c('blockquote', {
    staticClass: "hanging_indent"
  }, [_c('p', [_vm._v("Jack the lad Horner,")]), _vm._v(" "), _c('p', [_vm._v("Crouched in his corner")]), _vm._v(" "), _c('p', [_vm._v("Fingering a Christmas pie")]), _vm._v(" "), _c('p', [_vm._v("Stuck in a thumb,")]), _vm._v(" "), _c('p', [_vm._v("Pulled out a plum")]), _vm._v(" "), _c('p', [_vm._v("And said ‘Clever boy am I!’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 66
// module chunks = 0